
import { useState, useEffect } from 'react'

const defaultFallback = 'https://praysely.blob.core.windows.net/user-images/e31e7ade-f5be-4b3f-b33c-fbe6f58e8518.png'

const useImageLoader = (smallImage, largeImage, fallback = defaultFallback ) => {

    const [imageSource, setImageSource] = useState(smallImage)
    const [err, setError] = useState(false)

    useEffect(() => {
        setImageSource(smallImage) 

        const image = new Image()
        image.src = largeImage

        image.onload = () => { 
            setImageSource(largeImage)
        }
        
        image.onerror = () => { 
            setError(true)
            setImageSource(fallback)
        }

    }, [smallImage, largeImage, fallback])

    return [imageSource, { blur: imageSource === smallImage || err === true }]

}

export default useImageLoader